import type { Movie } from "@/types";

export const movies: Movie[] = [
  {
    id: "1001",
    title: "星际彼岸",
    type: "movie",
    genres: ["科幻", "冒险", "剧情"],
    region: "中国大陆",
    year: 2025,
    rating: 4.7,
    hotness: 9820,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%2C%20a%20lone%20astronaut%20silhouette%20standing%20before%20a%20giant%20glowing%20ringed%20planet%20and%20swirling%20nebula%2C%20deep%20navy%20blue%20and%20gold%20color%20scheme%2C%20dramatic%20volumetric%20light%20beams%2C%20high%20detail%20digital%20painting%2C%20vertical%20poster%20composition%2C%20moody%20epic%20atmosphere&width=600&height=900&seq=bbtv-poster-1001&orientation=portrait",
    synopsis: "当人类第一艘远航飞船抵达陌生星系，一段关于归途与信念的星际旅程就此展开。",
    story: "《星际彼岸》讲述了一支人类远航舰队在穿越虫洞后与母星失联的故事。船长老周必须在有限的能源与船员日渐低落的信念之间做出抉择。当他们在陌生星系发现一颗曾有人类活动痕迹的星球时，一个关于文明、牺牲与归属的宏大命题被缓缓揭开。影片以细腻的人物刻画与壮阔的太空影像，描绘了人类面对未知时最真实的情感。",
    director: "沈牧之",
    cast: ["周泊安", "林知夏", "陆延舟", "叶承宇"],
    releaseDate: "2025-07-18",
    tags: ["年度大片", "太空史诗", "口碑佳作"],
  },
  {
    id: "1002",
    title: "长安旧梦",
    type: "movie",
    genres: ["剧情", "历史", "爱情"],
    region: "中国大陆",
    year: 2024,
    rating: 4.5,
    hotness: 8610,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20historical%20movie%20poster%2C%20ancient%20Chinese%20elegant%20woman%20in%20silk%20hanfu%20under%20lantern%20light%20in%20a%20grand%20palace%20courtyard%2C%20deep%20navy%20and%20warm%20gold%20tone%2C%20soft%20mist%20and%20falling%20petals%2C%20refined%20digital%20painting%2C%20vertical%20poster%20composition%2C%20elegant%20romantic%20mood&width=600&height=900&seq=bbtv-poster-1002&orientation=portrait",
    synopsis: "一曲长安旧梦，两段错过的缘分，在繁华都城的灯火里交织成永恒。",
    story: "盛唐长安，乐师沈砚与贵族之女苏绾因一曲古谱相识，却因门第与时代的洪流被生生拆散。十年后战乱再起，两人在破败的都城重逢。影片以考究的服化道与诗意的镜头语言，讲述了一段跨越岁月的爱情与遗憾，勾勒出盛唐气象背后的悲欢离合。",
    director: "顾青岚",
    cast: ["许清和", "苏晚晴", "程俊逸"],
    releaseDate: "2024-11-02",
    tags: ["古装", "催泪", "美术惊艳"],
  },
  {
    id: "1003",
    title: "深海回声",
    type: "movie",
    genres: ["悬疑", "惊悚", "剧情"],
    region: "中国大陆",
    year: 2025,
    rating: 4.3,
    hotness: 7340,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20suspense%20movie%20poster%2C%20a%20submersible%20deep%20under%20dark%20ocean%20with%20a%20single%20searchlight%20beam%2C%20eerie%20glowing%20bioluminescent%20creatures%20nearby%2C%20deep%20navy%20black%20with%20faint%20teal%20and%20amber%20accents%2C%20claustrophobic%20tense%20mood%2C%20high%20detail%20digital%20painting%2C%20vertical%20poster%20composition&width=600&height=900&seq=bbtv-poster-1003&orientation=portrait",
    synopsis: "深潜队伍在万米海沟截获一段不该存在的回声，真相随着下潜层层逼近。",
    story: "一支深海科考队在执行例行任务时，声纳系统捕捉到一段规律异常的信号。随着下潜深度不断加大，队员之间的信任开始崩塌，而那段回声似乎隐藏着一段被刻意掩埋的往事。影片以密闭空间与心理博弈营造出持续升级的压迫感，探讨了科学探索与人性边界之间的距离。",
    director: "韩锐",
    cast: ["蒋昱", "温雨彤", "邵铭"],
    releaseDate: "2025-09-12",
    tags: ["烧脑", "深海", "短小精悍"],
  },
  {
    id: "1004",
    title: "追风者",
    type: "movie",
    genres: ["动作", "犯罪", "剧情"],
    region: "中国香港",
    year: 2024,
    rating: 4.2,
    hotness: 6980,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20action%20movie%20poster%2C%20a%20lone%20motorcyclist%20speeding%20through%20a%20rainy%20neon%20city%20street%20at%20night%2C%20dynamic%20motion%20blur%20and%20light%20trails%2C%20deep%20navy%20with%20vivid%20orange%20highlight%2C%20gritty%20high%20detail%20digital%20painting%2C%20vertical%20poster%20composition%2C%20intense%20adrenaline%20mood&width=600&height=900&seq=bbtv-poster-1004&orientation=portrait",
    synopsis: "一名退役车手被卷入城市走私案，为守护家人重上赛道与命运竞速。",
    story: "曾经的赛道之王程野隐姓埋名多年，却因弟弟卷入一场牵涉甚广的走私案被迫复出。在警方与犯罪团伙的双重夹击下，他必须凭借过人的车技与判断力在城市街头完成一场不可能的任务。影片动作场面凌厉，穿插着对亲情与救赎的细腻描写。",
    director: "罗启铭",
    cast: ["郑宇锋", "柯晴", "麦子豪"],
    releaseDate: "2024-12-20",
    tags: ["飙车", "高燃", "港味十足"],
  },
  {
    id: "1005",
    title: "城南往事",
    type: "movie",
    genres: ["剧情", "家庭"],
    region: "中国大陆",
    year: 2023,
    rating: 4.6,
    hotness: 5920,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20family%20drama%20movie%20poster%2C%20a%20nostalgic%20old%20Chinese%20town%20alley%20at%20golden%20dusk%20with%20warm%20window%20lights%2C%20an%20elderly%20figure%20and%20child%20silhouette%20walking%20together%2C%20deep%20navy%20shadows%20with%20amber%20highlights%2C%20tender%20nostalgic%20mood%2C%20refined%20digital%20painting%2C%20vertical%20poster%20composition&width=600&height=900&seq=bbtv-poster-1005&orientation=portrait",
    synopsis: "一条老街拆与不拆之间，三代人的记忆与选择被缓缓摊开。",
    story: "城南老巷即将改造，退休教师陈国栋坚持守着一间旧书店，而儿女们各有各的打算。随着老邻居陆续搬离，一家人在争执与回忆中重新理解了家的意义。影片以平实克制的笔触描绘普通中国家庭的温情与代沟，唤起了许多观众关于旧时光的共鸣。",
    director: "李承泽",
    cast: ["陈国栋", "王秀兰", "李念"],
    releaseDate: "2023-06-01",
    tags: ["现实题材", "温情", "高口碑"],
  },
  {
    id: "1006",
    title: "午夜列车",
    type: "movie",
    genres: ["悬疑", "惊悚"],
    region: "日本",
    year: 2025,
    rating: 4.1,
    hotness: 6210,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20mystery%20thriller%20movie%20poster%2C%20an%20empty%20vintage%20night%20train%20carriage%20interior%20with%20flickering%20lights%20and%20fogged%20windows%2C%20a%20single%20shadowy%20passenger%2C%20deep%20navy%20and%20desaturated%20amber%20palette%2C%20eerie%20suspended%20mood%2C%20high%20detail%20painting%2C%20vertical%20poster%20composition&width=600&height=900&seq=bbtv-poster-1006&orientation=portrait",
    synopsis: "一列只在午夜发车的列车，载着乘客驶向各自不愿面对的过去。",
    story: "深夜，一群素不相识的乘客登上一列没有终点站的列车。列车每到一站，就有一位乘客被迫面对自己最想逃避的秘密。随着车厢逐渐减少，众人开始怀疑这趟旅程的真正目的。影片以精巧的结构和层层反转，探讨了记忆与救赎的主题。",
    director: "小林健太",
    cast: ["高桥优真", "稻田美咲", "佐藤健吾"],
    releaseDate: "2025-03-28",
    tags: ["反转", "密闭空间", "日式悬疑"],
  },
  {
    id: "2001",
    title: "雾都迷案",
    type: "tv",
    genres: ["犯罪", "悬疑", "剧情"],
    region: "中国大陆",
    year: 2025,
    rating: 4.6,
    hotness: 9450,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20crime%20series%20poster%2C%20misty%20old%20city%20street%20at%20night%20with%20a%20detective%20trench%20coat%20silhouette%20and%20a%20glowing%20street%20lamp%2C%20deep%20navy%20fog%20with%20muted%20orange%20light%2C%20moody%20noir%20atmosphere%2C%20high%20detail%20digital%20painting%2C%20vertical%20poster%20composition&width=600&height=900&seq=bbtv-poster-2001&orientation=portrait",
    synopsis: "迷雾笼罩的旧城里，一桩尘封多年的旧案被重新翻开，牵出盘根错节的人情与真相。",
    story: "刑警队长老陆被调回故乡小城，接手一桩被定为意外的旧案。随着调查深入，他发现案件背后牵扯着当年的熟人、旧友甚至自己的家庭。全剧以浓郁的地域氛围与扎实的推理线，展现了一个关于正义与代价的漫长追索。",
    director: "周维",
    cast: ["陆铭川", "沈玉", "方卓", "何静宜"],
    releaseDate: "2025-05-09",
    tags: ["热播中", "刑侦", "年度口碑"],
  },
  {
    id: "2002",
    title: "山海谣",
    type: "tv",
    genres: ["奇幻", "古装", "爱情"],
    region: "中国大陆",
    year: 2024,
    rating: 4.4,
    hotness: 8970,
    cover: "https://readdy.ai/api/search-image?query=Epic%20Chinese%20fantasy%20series%20poster%2C%20a%20young%20cultivator%20in%20flowing%20robes%20standing%20on%20a%20floating%20mountain%20above%20cloud%20sea%2C%20mythical%20beasts%20and%20glowing%20runes%20in%20the%20sky%2C%20deep%20navy%20and%20jade%20with%20gold%20accents%2C%20dramatic%20ethereal%20lighting%2C%20high%20detail%20painting%2C%20vertical%20poster%20composition&width=600&height=900&seq=bbtv-poster-2002&orientation=portrait",
    synopsis: "上古山海之间的恩怨情仇，一段跨越种族的宿命之恋在乱世中萌芽。",
    story: "少年顾离为寻找失踪的兄长踏入传说中的山海之境，与守护灵兽的少女阿谣相识。两人在探寻上古封印真相的过程中，逐渐卷入人族与灵族的千年宿怨。剧集以宏大的世界观与精美的东方奇幻美学，构建了一个瑰丽而危险的世界。",
    director: "沈砚舟",
    cast: ["顾离", "阿谣", "墨珩", "青鸾"],
    releaseDate: "2024-08-15",
    tags: ["东方奇幻", "视觉盛宴", "宿命羁绊"],
  },
  {
    id: "2003",
    title: "我们的十年",
    type: "tv",
    genres: ["都市", "爱情", "青春"],
    region: "中国大陆",
    year: 2024,
    rating: 4.3,
    hotness: 8120,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20urban%20romance%20series%20poster%2C%20two%20young%20people%20silhouetted%20against%20a%20rainy%20city%20skyline%20at%20dusk%20with%20warm%20lights%2C%20deep%20navy%20and%20soft%20amber%20tone%2C%20reflective%20melancholic%20mood%2C%20refined%20digital%20painting%2C%20vertical%20poster%20composition%2C%20modern%20aesthetic&width=600&height=900&seq=bbtv-poster-2003&orientation=portrait",
    synopsis: "从校园到职场，一群年轻人的十年，是错过也是成长。",
    story: "大学同窗的林越与沈晴曾在毕业那天约定一起追梦，却在现实的分岔口走散。十年间，他们各自经历事业的起伏与感情的聚散，直到一次偶然的重逢让旧日的心结重新浮现。剧集以细腻的时代质感还原了一代年轻人的成长轨迹。",
    director: "温以宁",
    cast: ["林越", "沈晴", "周昊", "苏瑶"],
    releaseDate: "2024-04-26",
    tags: ["都市情感", "群像", "青春回忆"],
  },
  {
    id: "2004",
    title: "暗流",
    type: "tv",
    genres: ["权谋", "悬疑", "剧情"],
    region: "中国大陆",
    year: 2025,
    rating: 4.5,
    hotness: 7890,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20political%20thriller%20series%20poster%2C%20a%20man%20in%20a%20sharp%20suit%20standing%20before%20a%20towering%20glass%20office%20building%20at%20night%2C%20reflections%20and%20cold%20city%20lights%2C%20deep%20navy%20and%20steel%20grey%20with%20amber%20rim%20light%2C%20tense%20power%20struggle%20mood%2C%20high%20detail%20painting%2C%20vertical%20poster%20composition&width=600&height=900&seq=bbtv-poster-2004&orientation=portrait",
    synopsis: "平静的水面之下暗流涌动，一场关于权力与底线的无声较量。",
    story: "新上任的部门负责人江砚试图推动一项改革，却触动了盘踞多年的利益网络。在明与暗的交锋中，他必须分辨谁是盟友、谁是敌人。剧集以紧凑的节奏与冷静的镜头语言，刻画了职场与权谋中的人性博弈。",
    director: "韩立",
    cast: ["江砚", "任思远", "陆薇", "邵安"],
    releaseDate: "2025-02-14",
    tags: ["权谋", "高能", "烧脑"],
  },
  {
    id: "2005",
    title: "春日来信",
    type: "tv",
    genres: ["青春", "成长", "治愈"],
    region: "韩国",
    year: 2023,
    rating: 4.2,
    hotness: 6540,
    cover: "https://readdy.ai/api/search-image?query=Warm%20healing%20youth%20series%20poster%2C%20a%20cherry%20blossom%20tree%20in%20full%20bloom%20over%20a%20quiet%20school%20path%20with%20soft%20sunlight%20and%20a%20letter%20floating%20in%20the%20air%2C%20deep%20navy%20and%20gentle%20pink%20gold%20tone%2C%20nostalgic%20tender%20mood%2C%20refined%20digital%20painting%2C%20vertical%20poster%20composition&width=600&height=900&seq=bbtv-poster-2005&orientation=portrait",
    synopsis: "一封迟到多年的信，让两个年轻人在春天重新遇见了彼此。",
    story: "高三转学生韩世妍意外收到一封写给未来自己的旧信，信中指引她找到了同样迷茫的男孩车敏俊。两人在备考与成长的烦恼中互相治愈，也渐渐明白青春最珍贵的不是答案，而是同行的人。剧集节奏舒缓，画面清新治愈。",
    director: "朴志勋",
    cast: ["韩世妍", "车敏俊", "金多恩"],
    releaseDate: "2023-03-20",
    tags: ["治愈", "青春", "清新"],
  },
  {
    id: "3001",
    title: "快乐星球旅行团",
    type: "variety",
    genres: ["旅行", "真人秀"],
    region: "中国大陆",
    year: 2025,
    rating: 4.5,
    hotness: 8760,
    cover: "https://readdy.ai/api/search-image?query=Vibrant%20travel%20reality%20show%20poster%2C%20a%20group%20of%20cheerful%20travelers%20silhouetted%20on%20a%20mountain%20ridge%20at%20sunrise%20with%20backpacks%2C%20deep%20navy%20sky%20with%20warm%20orange%20sunrise%20glow%2C%20playful%20energetic%20mood%2C%20colorful%20stylized%20illustration%2C%20vertical%20poster%20composition&width=600&height=900&seq=bbtv-poster-3001&orientation=portrait",
    synopsis: "六位嘉宾结伴出发，用最朴素的方式丈量世界，也丈量彼此。",
    story: "《快乐星球旅行团》邀请六位性格迥异的嘉宾，以有限预算展开一场没有剧本的旅行。从雪山到海岛，他们在真实的相处中碰撞出笑料与感动。节目以轻快的剪辑与温暖的群像互动，成为许多观众周末放松的首选。",
    director: "节目组",
    cast: ["孟浩然", "乔安安", "大力", "小鹿"],
    releaseDate: "2025-06-06",
    tags: ["治愈综艺", "爆笑", "口碑炸裂"],
  },
  {
    id: "3002",
    title: "声生不息·经典季",
    type: "variety",
    genres: ["音乐", "竞演"],
    region: "中国大陆",
    year: 2024,
    rating: 4.4,
    hotness: 7980,
    cover: "https://readdy.ai/api/search-image?query=Music%20competition%20show%20poster%2C%20a%20singer%20silhouette%20on%20a%20dark%20stage%20surrounded%20by%20dramatic%20spotlights%20and%20sound%20wave%20visuals%2C%20deep%20navy%20and%20gold%20stage%20lighting%2C%20emotional%20powerful%20mood%2C%20high%20detail%20digital%20painting%2C%20vertical%20poster%20composition&width=600&height=900&seq=bbtv-poster-3002&orientation=portrait",
    synopsis: "经典金曲重新演绎，跨世代歌手同台，唱响属于每个人的回忆。",
    story: "节目集结不同年代的歌手，用全新的编曲重新诠释华语经典。每一期围绕一个主题展开，既有激烈的竞演，也有走心的合唱。舞台美术与现场乐队的高水准呈现，让节目成为年度最受关注的音乐综艺之一。",
    director: "节目组",
    cast: ["林曼", "周深白", "老张", "阿宇"],
    releaseDate: "2024-09-08",
    tags: ["音乐", "高音质", "情怀"],
  },
  {
    id: "3003",
    title: "向往的厨房",
    type: "variety",
    genres: ["生活", "美食"],
    region: "中国大陆",
    year: 2024,
    rating: 4.3,
    hotness: 6320,
    cover: "https://readdy.ai/api/search-image?query=Cozy%20lifestyle%20cooking%20show%20poster%2C%20a%20rustic%20warm%20open%20kitchen%20with%20fresh%20ingredients%20and%20steaming%20pots%2C%20soft%20afternoon%20sunlight%20through%20a%20window%2C%20deep%20navy%20and%20warm%20amber%20tone%2C%20inviting%20homey%20mood%2C%20refined%20digital%20painting%2C%20vertical%20poster%20composition&width=600&height=900&seq=bbtv-poster-3003&orientation=portrait",
    synopsis: "在乡村小院里，用一餐一饭治愈疲惫的心。",
    story: "嘉宾们远离城市，在一座乡村小院里经营一家只招待朋友的开放式厨房。每一期都有来自各地的家常菜谱、真实的人情往来，以及与自然相处的慢生活。节目以美食为线索，传递简单而温暖的生活哲学。",
    director: "节目组",
    cast: ["何大厨", "娜娜", "陈默"],
    releaseDate: "2024-05-17",
    tags: ["治愈", "下饭", "慢生活"],
  },
  {
    id: "3004",
    title: "爆笑实验室",
    type: "variety",
    genres: ["喜剧", "情景"],
    region: "中国大陆",
    year: 2025,
    rating: 4.1,
    hotness: 5870,
    cover: "https://readdy.ai/api/search-image?query=Playful%20comedy%20variety%20show%20poster%2C%20colorful%20stylized%20characters%20performing%20funny%20stage%20sketches%20with%20abstract%20geometric%20shapes%20and%20confetti%2C%20deep%20navy%20background%20with%20bright%20orange%20and%20yellow%20accents%2C%20humorous%20energetic%20mood%2C%20flat%20illustration%20style%2C%20vertical%20poster%20composition&width=600&height=900&seq=bbtv-poster-3004&orientation=portrait",
    synopsis: "一群喜剧人用脑洞大开的实验，测试你的笑点极限。",
    story: "节目把日常生活中的荒诞瞬间搬上舞台，通过情景短剧与即兴互动探讨各种奇妙假设。每期邀请不同嘉宾参与，笑点密集又贴近生活。轻松解压的风格让它成为许多观众的快乐源泉。",
    director: "节目组",
    cast: ["大熊", "小美", "老王", "圆子"],
    releaseDate: "2025-01-10",
    tags: ["爆笑", "解压", "下饭综艺"],
  },
  {
    id: "4001",
    title: "大地脉动",
    type: "documentary",
    genres: ["自然", "生态"],
    region: "中国大陆",
    year: 2024,
    rating: 4.8,
    hotness: 8450,
    cover: "https://readdy.ai/api/search-image?query=Stunning%20nature%20documentary%20poster%2C%20a%20vast%20mountain%20landscape%20with%20a%20lone%20migrating%20herd%20and%20dramatic%20cloud%20formations%2C%20deep%20navy%20sky%20with%20golden%20sunlight%20rays%20breaking%20through%2C%20epic%20reverent%20mood%2C%20high%20detail%20photographic%20composition%2C%20vertical%20poster&width=600&height=900&seq=bbtv-poster-4001&orientation=portrait",
    synopsis: "用最震撼的镜头，记录这片土地上生命与自然的永恒律动。",
    story: "《大地脉动》历时四年拍摄，跨越高原、森林、湿地与荒漠，记录无数鲜为人知的动植物生存故事。影片以史诗般的影像与沉静的叙事，展现了自然界的壮美与脆弱，也唤起人们对生态保护的思考。",
    director: "纪录片团队",
    cast: ["解说：钟远"],
    releaseDate: "2024-10-12",
    tags: ["震撼", "自然", "年度纪录片"],
  },
  {
    id: "4002",
    title: "丝路千年",
    type: "documentary",
    genres: ["历史", "人文"],
    region: "中国大陆",
    year: 2023,
    rating: 4.6,
    hotness: 6120,
    cover: "https://readdy.ai/api/search-image?query=Historical%20civilization%20documentary%20poster%2C%20an%20ancient%20caravan%20of%20camels%20crossing%20golden%20desert%20dunes%20at%20sunset%20with%20distant%20ruins%2C%20deep%20navy%20sky%20and%20warm%20amber%20sand%20tone%2C%20majestic%20timeless%20mood%2C%20high%20detail%20cinematic%20composition%2C%20vertical%20poster&width=600&height=900&seq=bbtv-poster-4002&orientation=portrait",
    synopsis: "重走古丝绸之路，在黄沙与遗迹间追溯文明的交流与回响。",
    story: "纪录片沿古丝路展开，从长安一路向西，通过考古发现、文献研究与实地探访，还原这条千年商路上的贸易、宗教与文化交流。影片以严谨的考据与唯美的影像，让历史变得鲜活而可感。",
    director: "纪录片团队",
    cast: ["解说：柳青"],
    releaseDate: "2023-09-15",
    tags: ["历史", "人文", "考据扎实"],
  },
  {
    id: "4003",
    title: "城市之光",
    type: "documentary",
    genres: ["社会", "人文"],
    region: "中国大陆",
    year: 2025,
    rating: 4.4,
    hotness: 5340,
    cover: "https://readdy.ai/api/search-image?query=Urban%20social%20documentary%20poster%2C%20a%20city%20skyline%20at%20blue%20hour%20with%20warm%20windows%20glowing%20and%20anonymous%20figures%20walking%20below%2C%20deep%20navy%20tones%20with%20amber%20city%20lights%2C%20contemplative%20human%20mood%2C%20refined%20cinematic%20composition%2C%20vertical%20poster&width=600&height=900&seq=bbtv-poster-4003&orientation=portrait",
    synopsis: "在城市的深夜与清晨之间，记录那些被看见与被忽略的普通人。",
    story: "纪录片把镜头对准城市里不同岗位的普通劳动者——夜班司机、急诊医生、守夜保安。通过一个个平凡却真实的片段，呈现城市运转背后无数个体的坚持与温度，让观众重新理解身边的世界。",
    director: "纪录片团队",
    cast: ["解说：田禾"],
    releaseDate: "2025-04-18",
    tags: ["现实", "人文关怀", "真实"],
  },
  {
    id: "4004",
    title: "舌尖上的街巷",
    type: "documentary",
    genres: ["美食", "人文"],
    region: "中国大陆",
    year: 2024,
    rating: 4.5,
    hotness: 7010,
    cover: "https://readdy.ai/api/search-image?query=Appetizing%20food%20documentary%20poster%2C%20a%20steaming%20street%20food%20stall%20at%20night%20with%20warm%20lanterns%20and%20a%20chef%20cooking%2C%20deep%20navy%20shadows%20with%20rich%20amber%20and%20red%20glow%2C%20warm%20inviting%20mood%2C%20high%20detail%20cinematic%20composition%2C%20vertical%20poster&width=600&height=900&seq=bbtv-poster-4004&orientation=portrait",
    synopsis: "走进城市街巷的烟火气，用一碗小吃讲述一座城的性格。",
    story: "每一集聚焦一座城市的代表性街巷美食，从清晨的早点摊到深夜的大排档，讲述食物背后摊主与食客的故事。纪录片以充满烟火气的影像，勾勒出中国城市里最真实动人的市井生活。",
    director: "纪录片团队",
    cast: ["解说：周野"],
    releaseDate: "2024-07-05",
    tags: ["美食", "烟火气", "下饭"],
  },
];

export const getMovieById = (id: string): Movie | undefined =>
  movies.find((item) => item.id === id);